module.exports = __webpack_public_path__ + "img/w3_copy_white.42b3eceb.png";